export default __webpack_public_path__ + "static/media/icon-pagination-first.50e60bda.svg";